import { defineMessages } from "react-intl";

export default defineMessages({
  kokonaismaaraJaSenKohdennukset: {
    id: "opiskelijamaara.kokonaismaaraJaSenKohdennukset",
    defaultMessage:
      "Kokonaisoppilas-/opiskelijamäärä mahdollisilla kohdennuksilla"
  },
  vainKohdennetutRajoitukset: {
    id: "opiskelijamaara.vainKohdennetutRajoitukset",
    defaultMessage: "Vain kohdennetut oppilas-/opiskelijamäärärajoitukset"
  },
  eiRajoiteta: {
    id: "opiskelijamaara.eiRajoiteta",
    defaultMessage: "Opiskelijamäärää ei rajoiteta"
  },
  osionInfoteksti: {
    id: "opiskelijamaara.osionInfoteksti",
    defaultMessage:
      "Opiskelijamäärää ei ole oletusarvoisesti rajoitettu. Ole hyvä ja tarkista rajoitteet lomakkeen lopusta."
  },
  kokonaismaara: {
    id: "opiskelijamaara.kokonaismaara",
    defaultMessage: "Kokonaisoppilas-/opiskelijamäärä"
  },
  yksittainenKohdennus: {
    id: "opiskelijamaara.yksittainenKohdennus",
    defaultMessage: "Yksittäinen oppilasmääräkohdennus"
  },
  kokonaismaaraEiRajattu: {
    id: "opiskelijamaara.kokonaismaaraEiRajattu",
    defaultMessage: "Kokonaisoppilas-/opiskelijamäärä: Ei rajattu"
  }
});
